import * as NUMBER from 'constant/number'
import * as FIELD_NAME from 'constant/form-item-names'
import * as FIELD_LABEL from 'constant/form-labels'
import React, { useEffect } from 'react'
import { Row, Col, Form, Select } from 'antd'
import PropTypes from 'prop-types'

const { Option } = Select

const AuthorForm = ({ article, form, authors }) => {
  useEffect(() => {
    form.setFieldsValue(article)
  }, [article])

  return (
    <Row gutter={NUMBER.FIFTY}>
      <Col>
        <Form
          form={form}
          layout='vertical'
        >
          <span>{FIELD_LABEL.AUTHOR}</span>
          <Form.Item name={FIELD_NAME.AUTHOR}>
            <Select
              bordered={false}
              placeholder={'Author'}
              showSearch={false}
              size='large'
              style={{ background: '#fff' }}
            >
              {authors?.map(({ first_name: firstName, last_name: lastName, uuid }) => (
                <Option
                  key={uuid}
                  value={uuid}
                >
                  {firstName + ' ' + lastName}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Col>
    </Row>
  )
}

AuthorForm.propTypes = {
  article: PropTypes.object,
  authors: PropTypes.array,
  form: PropTypes.object
}

export default AuthorForm
